import React, { useContext, useEffect } from 'react'

interface SiteTitleCtx {
  siteTitlePrefix: string
}

export const SiteTitleContext = React.createContext<SiteTitleCtx>({
  siteTitlePrefix: 'Lalilo',
})

export const DocumentTitle: React.FC<{ title: string }> = ({ title }) => {
  const { siteTitlePrefix } = useContext(SiteTitleContext)

  useEffect(() => {
    document.title = `${siteTitlePrefix} | ${title}`
  }, [siteTitlePrefix, title])

  return null
}
